import React, { Component, useRef, useEffect } from "react";
import BasicLayout from "../layouts/Basic";
import Responsive from "../layouts/Responsive";

import Title from "../components/Title";

import Onroof from "../sketches/Onroof";

const Roof = () => {
  return (
    <>
      <Responsive />
      <div className="book-wrapper">
        <div className="left-con">
          {/* <Title /> */}
          <div className="contents-wrapper">
            <div className="canvas-wrapper">
              <Onroof />
            </div>
            <div className="element-wrapper">
              <div className="clip"></div>
            </div>
          </div>
        </div>
        <BasicLayout />
      </div>
    </>
  );
};

export default Roof;
